import { Injectable, Renderer2, RendererFactory2, DOCUMENT, inject } from '@angular/core';

import { SecurityService } from './security.service';
import { PreferencesService } from './preferences/preferences.service';

@Injectable({
  providedIn: 'root'
})
export class WebbrokerResponsiveService {
  private readonly document = inject<Document>(DOCUMENT);
  private readonly securityService = inject(SecurityService);
  private readonly preferencesService = inject(PreferencesService);

  private renderer: Renderer2;

  constructor() {
    const rendererFactory = inject(RendererFactory2);

    this.renderer = rendererFactory.createRenderer(null, null);
  }

  init(): void {
    const usingResponsive = this.preferencesService
      .getPreloadedUserPreference<boolean>('USING_RESPONSIVE') ?? true;
    this.setContentAttribute(usingResponsive);
    this.preferencesService.onResponsivePreferenceChange.subscribe(
      (result: boolean): void => this.setContentAttribute(result));
  }

  private setContentAttribute(usingResponsive: boolean): void {
    const responsiveEnabled = this.securityService.hasPermission('RESPONSIVE_VIEW')
      && usingResponsive;
    const metaElement = this.document.getElementById('td-wb-meta-viewport');
    if (responsiveEnabled) {
      this.renderer.setAttribute(metaElement, 'content', 'width=device-width, initial-scale=1.0');
    } else {
      this.renderer.setAttribute(metaElement, 'content', 'width=1024, initial-scale=1.0');
    }
  }
}
